import { getClassedFormHelperText } from "./formHelperText.styles";
import type { FormHelperTextProps } from "./formHelperText.types";

export const FormHelperText = ({ children, state, disabled, className }: FormHelperTextProps) => (
  <span className={getClassedFormHelperText({ state, disabled, className })}>{children}</span>
);
